import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 290px;
  height: 410px;
  border: 1.98px solid #CBD2D4;
  border-radius: 19.49px;
  position: relative;

  > svg {
    left: calc(50% - 2.64px);
    margin-top: 15.17px;
    position: absolute;
  }
`;

export const ScreenWrapper = styled.div`
  width: 250.13px;
  height: 333.97px;
  margin: 36.28px 18.16px 35.96px 18.17px;
  border: 2px solid #343434;
  border-radius: 1px;
  text-align: center;
  color: #FFFFFF;
`;

export const HomeButton = styled.div`
  width: 18.5px;
  height: 18.47px;
  border: 1.32px solid #CBD2D4;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: calc(50% - 9.235px);
  margin-bottom: 7.92px;
`;

export const Wrapper2 = styled.div`
  width: 300px;
  height: 418px;
  border-radius: 19.49px;
  position: absolute;
  right: 0;
  ${({ deviceSrc }) => `background-image: url(${deviceSrc})`}
`;

export const ScreenWrapper2 = styled.div`
  width: 270.13px;
  height: 385.97px;
  margin: 17.28px 13.16px 34.96px 14.17px;
  border: 2px solid #343434;
  text-align: center;
  color: #FFFFFF;
  border-radius: 6px;

  >div {
    border-radius: 3px;
  }
`;

export const BrowserWrapper = styled.div`
  width: 300px;
  height: 205px;
  position: absolute;
  right: 0;
  ${({ deviceSrc }) => `background-image: url(${deviceSrc})`}
  background-size: contain;
  background-repeat: no-repeat;
`;

export const ScreenBrowserWrapper = styled.div`
  width: 100%;
  height: calc(100% - 9px);
  margin-top: 10px;
  text-align: center;
  color: #FFFFFF;
`;